import { render, staticRenderFns } from "./document-list.vue?vue&type=template&id=1cb0f9d8&lang=pug&"
import script from "./document-list.vue?vue&type=script&lang=js&"
export * from "./document-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports